import { COMPANYFOLDERLIST_SEARCH, COMPANYFOLDERLIST_PAGE } from '../actions/companyfolderlistactions';

const state = { search: '', page: 0 };

const getters = {
    page: state => state.page,
    search: state => state.search
};

const actions = {
    [COMPANYFOLDERLIST_SEARCH]: ({ commit }, search) => {
        commit(COMPANYFOLDERLIST_SEARCH, search);
    },
    [COMPANYFOLDERLIST_PAGE]: ({ commit }, page) => {
        commit(COMPANYFOLDERLIST_PAGE, page);
    }
};

const mutations = {
    [COMPANYFOLDERLIST_SEARCH]: (state, search) => {
        state.page = 0;
        state.search = search;
    },
    [COMPANYFOLDERLIST_PAGE]: (state, page) => {
        state.page = page;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};